function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _Symbol from "@babel/runtime-corejs3/core-js/symbol";
import _Number$isInteger from "@babel/runtime-corejs3/core-js/number/is-integer";
import React from "react";
var $min = _Symbol('min');
var $max = _Symbol('max');
export var InclusiveRange = /*#__PURE__*/function () {
  function InclusiveRange(min, max) {
    _classCallCheck(this, InclusiveRange);
    if (typeof min !== 'number' || typeof max !== 'number') {
      throw TypeError('Expected min and max to be numbers');
    }
    if (min > max) {
      throw TypeError('Expected min to be less than or equal to max');
    }
    if (!_Number$isInteger(min) || !_Number$isInteger(max)) {
      throw TypeError('Expected min and max to be integers');
    }
    this[$min] = min;
    this[$max] = max;
  }
  _createClass(InclusiveRange, [{
    key: "min",
    get: function get() {
      return this[$min];
    }
  }, {
    key: "max",
    get: function get() {
      return this[$max];
    }
  }, {
    key: "map",
    value: function map(mapper) {
      return new this.constructor(mapper(this[$min]), mapper(this[$max]));
    }
  }, {
    key: "includes",
    value: function includes(number) {
      return number >= this.min && number <= this.max;
    }
  }, {
    key: "length",
    get: function get() {
      return Math.max(this.max - this.min + 1, 0);
    }
  }, {
    key: "restrict",
    value: function restrict(number) {
      return Math.min(this.max, Math.max(this.min, number));
    }
  }]);
  return InclusiveRange;
}();
export var ExclusiveRange = /*#__PURE__*/function (_InclusiveRange) {
  _inherits(ExclusiveRange, _InclusiveRange);
  var _super = _createSuper(ExclusiveRange);
  function ExclusiveRange() {
    _classCallCheck(this, ExclusiveRange);
    return _super.apply(this, arguments);
  }
  _createClass(ExclusiveRange, [{
    key: "min",
    get: function get() {
      return this[$min] + 1;
    }
  }, {
    key: "max",
    get: function get() {
      return this[$max] - 1;
    }
  }]);
  return ExclusiveRange;
}(InclusiveRange);
export var useInclusiveRange = function useInclusiveRange(min, max) {
  return React.useMemo(function () {
    return new InclusiveRange(min, max);
  }, [min, max]);
};